import React, {useEffect} from "react";
import {useParams} from "react-router-dom";
import {fetchVendorById} from "../../store/vendor-slice";
import {useDispatch, useSelector} from "react-redux";
import SubHeader from "../../components/header/SubHeader";
import Button from "../../components/common/button/Button";
import Detail from "../../components/common/detail/Detail";
import {getDetailData} from "../../models/vendorModel";
import {getValidatedLimit} from "../../components/Utility";
import {fetchExpenseList} from "../../store/list-slice"; // Adjust to your actual model import

const VendorDetails = () => {
    const params = useParams();
    const dispatch = useDispatch();
    const {pagination} = useSelector(state => state.vendor);
    const {limit, currentPage} = getValidatedLimit(pagination);
    const userRole = useSelector((state) => state.auth.selectedRole);
    const list = useSelector(state => state.list);

    useEffect(() => {
        dispatch(fetchVendorById({...userRole, id: params.vendorId})); // Adjust based on your actual Redux action
    }, [dispatch, params.vendorId, userRole]);

    const {
        items: vendors,
        fetchByIdStatus,
        error
    } = useSelector(state => state.vendor); // Adjust based on your Redux slice

    useEffect(() => {
        dispatch(fetchExpenseList())
    }, [dispatch])

    const vendor = vendors.find(vendor => vendor.id === params.vendorId); // Ensure correct id matching
    const detailData = getDetailData({item: vendor, list}); // Adjust this to fit how you process data for details

    return (
        <>
            <SubHeader title="Vendor Details">
                <Button to={`../?page=${currentPage}&limit=${limit}`}
                        className="btn-sm bg-secondary bg-opacity-50">Back</Button>
            </SubHeader>
            <div className="container p-0 ms-0">
                {fetchByIdStatus === "loading" && <p>Loading...</p>}
                {fetchByIdStatus === "failed" && <h6 className="text-danger">{error}</h6>}
                {fetchByIdStatus === "success" && <Detail inline={true} columns={{lg: 9, xl: 7}} data={detailData}/>}
            </div>
        </>
    );
};

export default VendorDetails;
